import {Component, OnInit} from '@angular/core';
import {Tab} from '../tabconfig/tab.model';
import {TabService} from '../tabconfig/tab.service';

import { HomeComponent } from '../modules/home/home.component';
import { StudentsListComponent } from '../modules/maintenance/students/students-list/students-list.component'
import { EmployeeListComponent } from '../modules/maintenance/employee/employee-list/employee-list.component';
import { CoursesListComponent } from '../modules/maintenance/courses/courses-list/courses-list.component';
import { ModulesListComponent } from '../modules/maintenance/modules/modules-list/modules-list.component';
import { QuestionsListComponent } from '../modules/maintenance/questions/questions-list/questions-list.component';
import { AuthService } from '../system/auth.service';
import { ParametersListComponent } from '../modules/configuration/paramters/parameters-list/parameters-list.component';
import { ParametersComponent } from '../modules/configuration/parameters/parameters.component';
import { EmployeeQuizComponent } from '../modules/maintenance/employee/employee-quiz/employee-quiz.component';
import { CoursesQuizComponent } from '../modules/maintenance/courses/courses-quiz/courses-quiz.component';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent implements OnInit {

  tabs = new Array<Tab>();
  selectedTab: number;
  parameters: any[];

  emp_in_rol_type:string;

  constructor(
    private tabService: TabService,
    private authService: AuthService
  ) { }

  ngOnInit() {
    
    this.LoadInitial();
    this.emp_in_rol_type = this.authService.getPerfilID();
    this.tabService.tabSub.subscribe(tabs => {
      this.tabs = tabs;
      this.selectedTab = tabs.findIndex(tab => tab.active);
    });
  }

  tabChanged(event) {
    console.log("tab changed");
  }

  public LoadInitial() {
    this.parameters = this.authService.getParameters();
  }
  addNewTab(componente,element) {
    switch (componente) {
      case 0:
        this.tabService.addTab(new Tab(HomeComponent, "Inicio", { parent: "AppComponent" }));
        break;
      case 1:
        this.tabService.addTab(new Tab(StudentsListComponent, "Listado de Estudiantes", { parent: "AppComponent" }));
        break;
      case 2:
        this.tabService.addTab(new Tab(EmployeeListComponent, "Listado Profesor y Administrador", { parent: "AppComponent" }));
        break;
      case 3:
        this.tabService.addTab(new Tab(CoursesListComponent, "Listado Cursos", { parent: "AppComponent" }));
        break;
      case 4:
        this.tabService.addTab(new Tab(ParametersComponent, element.sys_vc_description, { parent: "AppComponent" , element: element}));
        break;
        case 5:
        this.tabService.addTab(new Tab(EmployeeQuizComponent, 'Encuesta de Profesor', { parent: "AppComponent" , element: element}));
        break;
        case 6:
        this.tabService.addTab(new Tab(CoursesQuizComponent, 'Encuesta del curso', { parent: "AppComponent" , element: element}));
        break;
        
    }
  }

  removeTab(index: number): void {
    this.tabService.removeTab(index);
  }

}
